import styled from 'styled-components';
import { visuallyHiddenStyles } from 'modules/VisuallyHidden';
import { padding, unit } from 'modules/spacing';
import { themeGet } from 'modules/tetrisTheme';
import { fontSize, fontWeight } from 'modules/theme';
export const Container = styled.a `
  ${padding(0)};
  ${fontSize('base', 1)};
  ${fontWeight('semibold')};
  ${visuallyHiddenStyles};
  text-decoration: none;
  text-transform: uppercase;
  color: ${themeGet('colors.primary.500')};

  &:focus-visible {
    ${padding(2)};
    position: fixed;
    top: ${unit(4)};
    left: ${unit(4)};
    width: auto;
    height: auto;
    z-index: 100;
    background: ${themeGet('colors.gray.0')};
    clip: auto;
    outline: none;
  }
`;
